import { render } from "./PPAPApplicabilityDocumentList.vue?vue&type=template&id=4621f811&scoped=true"
import script from "./PPAPApplicabilityDocumentList.vue?vue&type=script&lang=js"
export * from "./PPAPApplicabilityDocumentList.vue?vue&type=script&lang=js"

import "./PPAPApplicabilityDocumentList.vue?vue&type=style&index=0&id=4621f811&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4621f811"]])

export default __exports__